import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class FiveValueButtons extends DesigntimeComponent {
    static staticName = "Five Buttons with value";
    static staticId = "fiveValueButtons";
    runtimeValue = null;
    runtimeButtonText = "";

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            header: { value: "How much?" },
            button1: { value: "Less" },
            value1: { value: 0.25, dontTranslate: true },
            button2: { value: "-" },
            value2: { value: 0.5, dontTranslate: true },
            button3: { value: "Same" },
            value3: { value: 1, dontTranslate: true },
            button4: { value: "-" },
            value4: { value: 2, dontTranslate: true },
            button5: { value: "More" },
            value5: { value: 4, dontTranslate: true },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var $view = $("<div></div>");
        $view.append("<h2>" + this.values.header.value + "</h2>")

        $view.append(this.getButton(this.values.button1.value, this.values.value1.value));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button2.value, this.values.value2.value));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button3.value, this.values.value3.value));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button4.value, this.values.value4.value));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button5.value, this.values.value5.value));
        $view.append($("<br />"));

        return $view;
    }

    getButton(buttonText, buttonValue) {
        var $button = $(`<input class='sid-question-button' type='button' value='${buttonText}' data-result='${buttonValue}'></input >`);
        $button.click(function (e) {
            componentHelpers.getRtFrame(this.id).find(".sid-question-button").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.runtimeValue = $(e.currentTarget).data("result");
            this.runtimeButtonText = $(e.currentTarget).val();
            this.enableNextButton();
        }.bind(this));
        return $button;
    }

    getOutput() {
        return {
            value: this.runtimeValue,
            buttontext: this.runtimeButtonText
        };
    }

    output = [
        { name: "value", type: "number" },
        { name: "buttontext", type: "string" }
    ];
}

export { FiveValueButtons }
